<script setup lang="ts">
import LimitedPackBadgeImage from '@/assets/images/limited-pack-badge.png'
import { formatDuration } from '@/helpers/date'
import { usePacks } from '@/composables/game/shop'
import LimitedPack from '@/components/LimitedPack.vue'

const { activeLimitedPackItem, countdownForLimitedPackEnd } = usePacks()

</script>

<template>
  <LimitedPack
    v-if="activeLimitedPackItem"
    :limited-pack="activeLimitedPackItem"
  >
    <div class="absolute -left-4 -top-4 h-[48px] z-[3]">
      <div class="relative h-full w-full">
        <img
          :src="LimitedPackBadgeImage"
          class="h-full w-auto object-cover"
        >
        <div class="absolute left-0 right-0 top-2 rotate-[-23deg] w-full overflow-visible">
          <span class="golden-text-with-black-stroke uppercase font-[800] text-[13px] leading-3 whitespace-pre-line w-full overflow-visible inline-block h-max text-center">
            {{ activeLimitedPackItem.name }}
          </span>
        </div>
      </div>
    </div>
    <div class="absolute left-1/2 -translate-x-1/2 h-[18px] px-1.5 top-[38px] rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-dark-top-most-layer whitespace-nowrap">
      <span class="text-red-accent">
        {{ formatDuration(countdownForLimitedPackEnd, undefined, countdownForLimitedPackEnd> (3600 * 72)) }}
      </span>
    </div>
  </LimitedPack>
</template>
<style scoped>
.golden-text-with-black-stroke {
  color: #FFD41E;
  -webkit-background-clip: text;
  text-shadow:
    1.2px -1.2px 0 #000,
    -1.2px 1.2px 0 #000,
    1.2px 1.2px 0 #000,
    -1.2px 0 0 #000,
    1.2px 0 0 #000,
    0 -1.2px 0 #000,
    0 1.2px 0 #000,
    -1.2px -1.2px 0 #000,
    1.2px -1.2px 0 #000,
    -1.2px 1.2px 0 #000,
    1.2px 1.2px 0 #000;
}

.golden-text-with-black-stroke::first-line {
  font-size: 11px;
  line-height: 10px;
}

</style>
